import { get, post, put, deleteUrl, postUrl } from './index'

import base from './base'

const api = base

export default {
    getJson: (code, fn) => { // 获取JSON串
        return get(api + 'setting/getByCode/' + code).then(res => {
            fn(res && res.data && res.data[0] && res.data[0].content ? JSON.parse(res.data[0].content) : '')
        })
    },
    getStudentExamRes: (data) => {  
       return get(api + 'jeecg-boot/web/exam/evaexam', data)
    },
    //登录注册
    getLogin: (data) => {  //登录
        return post(api + 'jeecg-boot/web/login/emailLogin', data)
    },
    getWXLogin: (data) => {  //微信登录
        return post(api + 'jeecg-boot/web/login/wxLogin', data)
    },
    completeInformation: (data) => {  //完善账号信息(微信扫码后)
        return post(api + 'jeecg-boot/web/login/completeInformation', data)
    },
    updateUserInfo: (data) => {  //修改个人信息
        return post(api + 'jeecg-boot/web/login/updateUserInfo', data)
    },
    getEmailCode: (data) => {  //获取邮箱验证码
        return get(api + 'jeecg-boot/web/login/getEmailCode', data)
    },
    getUserInfo: (data) => {  //得到个人信息
        return get(api + 'jeecg-boot/web/login/getUserInfo', data)
    },
    updatePassWord: (data) => {  //修改密码
        return post(api + 'jeecg-boot/web/login/updatePassWord', data)
    },
    getregister: (data) => {  //注册
        return post(api + 'jeecg-boot/web/login/register', data)
    },
    getBlans: (data) => {  
        return get(api + 'jeecg-boot/web/home/getUserLearnInfo', data)
    },
    resetPassword: (data) => {  //重置密码
        return put(api + 'jeecg-boot/web/login/resetPassword', data)
    },
    //首页
    getHomeBanner: (data) => {  //首页banner
        return get(api + 'jeecg-boot/web/home/getBannerList', data)
    },
    geTentranceExam: (data) => {  //新手小白PTE入学试卷
        return get(api + 'jeecg-boot/web/home/geTentranceExam', data)
    },
    getEaxmHandbook: (data) => {  //考试指南
        return get(api + 'jeecg-boot/web/home/getEaxmHandbook', data)
    },
    getExamLearnPlan: (data) => {  //查询目标分数
        return get(api + 'jeecg-boot/web/home/getExamLearnPlan', data)
    },
    getHfData: (data) => {  //查询高频练习数据
        return get(api + 'jeecg-boot/web/home/getHfData', data)
    },
    getHomeRecallQuestions: (data) => {  //首页考试回忆
        return get(api + 'jeecg-boot/web/home/getHomeRecallQuestions', data)
    },
    getMyWordBookData: (data) => {  //我的单词本
        return get(api + 'jeecg-boot/web/home/getMyWordBookData', data)
    },
    getUserTodayLearn: (data) => {  //查询今日计划
        return get(api + 'jeecg-boot/web/home/getUserTodayLearn', data)
    },
    setExamLearnPlan: (data) => {  //设置目标分数
        return post(api + 'jeecg-boot/web/home/setExamLearnPlan', data)
    },
    setTodayLearnPlan: (data) => {  //设置今日计划
        return post(api + 'jeecg-boot/web/home/setTodayLearnPlan', data)
    },
	submitRemark: (data) => {  //设置今日计划
	    return post(api + 'jeecg-boot/web/home/submitRemark', data)
	},
	getIsStudent: (data) => {  //查询是否学生和所属班级
	    return get(api + 'jeecg-boot/web/home/getIsStudent', data)
	},
	getqueryConfig: (data) => {  //查询是否学生和所属班级
	    return get(api + 'jeecg-boot/web/ptePlatformConfig/queryConfig', data)
	},
	
	
	
	//考试回忆
	addExamRecall: (data) => {  //添加考试回忆
	    return post(api + 'jeecg-boot/web/examRecall/addExamRecall', data)
	},
	addComments: (data) => {  //添加考试回忆
	    return post(api + 'jeecg-boot/web/examRecall/addComment', data)
	},
	getComments: (data) => {  //添加考试回忆
	    return get(api + 'jeecg-boot/web/examRecall/getComments', data)
	},
	getRecalls: (data) => {  //得到回忆列表
	    return get(api + 'jeecg-boot/web/examRecall/getRecalls', data)
	},
	addRecallLike: (data) => {  //点赞-取消点赞回忆
	    return get(api + 'jeecg-boot/web/examRecall/addRecallLike', data)
	},
	getRecallQuestions: (data) => {  //得到考场回忆题目列表
	    return get(api + 'jeecg-boot/web/examRecall/getRecallQuestions', data)
	},
	
	searchQuestions: (data) => {  //搜索题目
	    return get(api + 'jeecg-boot/web/questions/searchQuestions', data)
	},
	searchQuestionsTypeCode: (data) => {  //搜索题目得到所有题型
	    return get(api + 'jeecg-boot/web/questions/searchQuestionsTypeCode', data)
	},
	
	
	 //本周高频
    getQuestionsByTypeCode: (data) => {  //根据类型得到题目列表
        return get(api + 'jeecg-boot/web/questions/getQuestionsByTypeCode', data)
    },
    getTodayQuestionsByTypeCode: (data) => {  //根据类型得到题目列表
        return get(api + 'jeecg-boot/web/questions/getTodayQuestionsByTypeCode', data)
    },
    resetAllPracticedAns: (data) => {  //清空已做题目
        return get(api + 'jeecg-boot/web/questions/resetAllPracticedAns', data)
    },
    getQuestionsParentTypes: (data) => {  //得到题目大分类
        return get(api + 'jeecg-boot/web/questions/getQuestionsParentTypes', data)
    },
    getQuestionsTypes: (data) => {  //得到题目类型(细)
        return get(api + 'jeecg-boot/web/questions/getQuestionsTypes', data)
    },
    getTypeInfoByHif: (data) => {  //得到高频各题型和题目数
        return get(api + 'jeecg-boot/web/questions/getTypeInfoByHif', data)
    },
    getTypeInfoByDayPlan: (data) => {  //得到每日练习各题型和题目数
        return get(api + 'jeecg-boot/web/questions/getTypeInfoByDayPlan', data)
    },
    getQuestionsTypeInfo: (data) => {  //得到练习题型数据
        return get(api + 'jeecg-boot/web/questions/getQuestionsTypeInfo', data)
    },
    myQuestionPractices: (data) => {  //我的练习列表
        return get(api + 'jeecg-boot/web/questions/myQuestionPractices', data)
    },
    queryQuestionById: (data) => {  //题目详情
        return get(api + 'jeecg-boot/web/questions/queryQuestionById', data)
    },
     queryQuestionPractices: (data) => {  //题目练习打卡列表
        return get(api + 'jeecg-boot/web/questions/queryQuestionPractices', data)
    },
     queryHitRate: (data) => {  //查询预测大数据
        return get(api + 'jeecg-boot/web/questions/queryHitRate', data)
    },
     saveNote: (data) => {  //保存题目笔记
        return post(api + 'jeecg-boot/web/questions/saveNote', data)
    },
    getRecommendQuesionsNum: (data) => {  //得到推荐题目各题型数量
        return get(api + 'jeecg-boot/web/questions/getRecommendQuesionsNum', data)
    },
     getRecommendQuesions: (data) => {  //得到老师推荐题目
        return get(api + 'jeecg-boot/web/questions/getRecommendQuesions', data)
    },
    getQustionsBySort: (data) => {  //高频和练习得到上-下一题
        return get(api + 'jeecg-boot/web/questions/getQustionsBySort', data)
    },
    getQueListByHifHtml: (data) => {  //得到高频list的Html
        return get(api + 'jeecg-boot/web/questions/getQueListByHifHtml', data)
    },
    getQueListByExamHtml: (data) => {  //得到高频list的Html
        return get(api + 'jeecg-boot/web/questions/getQueListByExamHtml', data)
    },
    
    
    //真题单词
    getExamWordTypes: (data) => {  //得到真题单词分类列表
        return get(api + 'jeecg-boot/web/word/getExamWordTypes', data)
    },
    getExamWordListByUser: (data) => {  //得到用户真题单词列表
        return get(api + 'jeecg-boot/web/word/getExamWordListByUser', data)
    },
    addWordReviewNum: (data) => {  //复习单词
        return post(api + 'jeecg-boot/web/word/addWordReviewNum', data)
    },
    getExamWordByType: (data) => {  //更新单词掌握状态
        return post(api + 'jeecg-boot/web/word/getExamWordByType', data)
    },
    getWord: (data) => {  //查询单词
        return get(api + 'jeecg-boot/web/word/getWord', data)
    },
    updateLearnWord: (data) => {  //更新单词掌握状态
        return post(api + 'jeecg-boot/web/word/updateLearnWord', data)
    },
    addMyWordBook: (data) => {  //加入我的单词表
        return post(api + 'jeecg-boot/web/word/addMyWordBook', data)
    },
    queryByWord: (data) => {  //PTE单词查询
        return get(api + 'jeecg-boot/web/word/queryByWord', data)
    },
    
    //视频课堂
    getVideoList: (data) => {  //得到视频课堂列表
        return get(api + 'jeecg-boot/web/video/getVideoList', data)
    },
    //视频课堂Token
    getVideoToken: (data) => {  //得到视频课堂列表
        return get(api + 'jeecg-boot/web/video/getVideoToken', data)
    },
    //作业练习
    getWorkTypeList: (data) => {  //得到作业练习类型
        return get(api + 'jeecg-boot/web/classWork/getWorkTypeList', data)
    },
    normalPracToTeacher: (data) => {  //点赞-取消点赞问题评论
        return get(api + 'jeecg-boot/web/classWork/normalPracToTeacher', data)
    },
    getWorkList: (data) => {  //得到作业练习列表
        return get(api + 'jeecg-boot/web/classWork/getWorkList', data)
    },
    //题目评论接口
    addComment: (data) => {  //增加问题评论
        return post(api + 'jeecg-boot/web/comment/addComment', data)
    },
    addTrendsCommentLike: (data) => {  //点赞-取消点赞问题评论
        return get(api + 'jeecg-boot/web/comment/addTrendsCommentLike', data)
    },
    delComment: (data) => {  //删除问题评论
        return get(api + 'jeecg-boot/web/comment/delComment', data)
    },
    getQuestionComments: (data) => {  //问题评论列表
        return get(api + 'jeecg-boot/web/comment/getQuestionComments', data)
    },
    
    
    //整套模考
    geExamListByType: (data) => {  //根据类型得到试卷列表
        return get(api + 'jeecg-boot/web/exam/geExamListByType', data)
    },
    geExamTypes: (data) => {  //得到试卷类型列表
        return get(api + 'jeecg-boot/web/exam/geExamTypes', data)
    },
    getExamTotalScore: (data) => {  //得到考试最终成绩
        return get(api + 'jeecg-boot/web/exam/getExamTotalScore', data)
    },
    getExamWQuestionList: (data) => {  //得到试卷题目
        return get(api + 'jeecg-boot/web/exam/getExamWQuestionList', data)
    },
    getSpecialList: (data) => {  //得到专项类型列表
        return get(api + 'jeecg-boot/web/exam/getSpecialList', data)
    },
    getExamWQuestionList: (data) => {  //得到试卷题目
        return get(api + 'jeecg-boot/web/exam/getExamWQuestionList', data)
    },
    queryExamQualify: (data) => {  //查询是否有考试资格
        return post(api + 'jeecg-boot/web/exam/queryExamQualify', data)
    },
    getExamScore: (data) => {  //查询考试成绩
        return get(api + 'jeecg-boot/web/exam/getExamScore', data)
    },
    findUserExamPlan:(data)=>{ //查询用户对应试卷是否有答题进度
        return get(api + 'jeecg-boot/web/exam/findUserExamPlan',data)
    },

    //题目收藏
    add: (data) => {  //添加题目收藏夹
        return post(api + 'jeecg-boot/web/questionCollect/add', data)
    },
    collectQuestion: (data) => {  //收藏题目
        return post(api + 'jeecg-boot/web/questionCollect/collectQuestion', data)
    },
    delete: (data) => {  //删除收藏夹
        return deleteUrl(api + 'jeecg-boot/web/questionCollect/delete', data)
    },
    getCollectFolders: (data) => {  //得到收藏夹列表
        return get(api + 'jeecg-boot/web/questionCollect/getCollectFolders', data)
    },
    getQuestionsByFolder: (data) => {  //得到收藏夹题目列表
        return get(api + 'jeecg-boot/web/questionCollect/getQuestionsByFolder', data)
    },
    getCollectTypeNum: (data) => {  //得到收藏夹各题型数量
        return get(api + 'jeecg-boot/web/questionCollect/getCollectTypeNum', data)
    },
    delCollectQuestion: (data) => {  //删除收藏题目
        return get(api + 'jeecg-boot/web/questionCollect/delCollectQuestion', data)
    },
    
    //生成订单 会员
    generateOrder: (data) => {  //生成订单
        return get(api + 'jeecg-boot/web/order/generateOrder', data)
    },
    getProductList: (data) => {  //得到商品列表
        return get(api + 'jeecg-boot/web/order/getProductList', data)
    },
    
    //历史成绩
    historyGradelist: (data) => {  //查询历史成绩单列表
        return get(api + 'jeecg-boot/web/historyGrade/list', data)
    },
    historyGradeadd: (data) => {  //添加历史成绩
        return post(api + 'jeecg-boot/web/historyGrade/add', data)
    },
    historyGradedelete: (data) => {  //删除历史成绩单
        return get(api + 'jeecg-boot/web/historyGrade/delete', data)
    },
    
    //意见反馈
    feedbackpay: (data) => {  //得到反馈类型
        return get(api + 'jeecg-boot/web/feedback/pay', data)
    },
    submitFeedback: (data) => {  //提交意见反馈
        return post(api + 'jeecg-boot/web/feedback/submitFeedback', data)
    },
    
    
    
    //用户做题
    aiSocreBySpeaking: (data) => {  //AI评分(口语-RA,RS,DI,RL)
        return get(api + 'jeecg-boot/web/submitQuestions/aiSocreBySpeaking', data)
    },
    getAiSocreByAsq: (data) => {  //AI评分-(口语-ASQ)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreByAsq', data)
    },
    getAiSocreBySst: (data) => {  //AI评分-(SST)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreBySst', data)
    },
    getAiSocreBySwt: (data) => {  //AI评分-(SWT)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreBySwt', data)
    },
    getAiSocreByWe: (data) => {  //AI评分-(WE)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreByWe', data)
    },
    getAiSocreByWfd: (data) => {  //AI评分-(WFD)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreByWfd', data)
    },
    getSocreByFibl: (data) => {  //普通评分-(FIB-L)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByFibl', data)
    },
    getSocreByFibr: (data) => {  //普通评分-(FIB-R)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByFibr', data)
    },
    getSocreByFibrw: (data) => {  //普通评分-(FIB-RW)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByFibrw', data)
    },
    
    getSocreByHiw: (data) => {  //普通评分-(HIW)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByHiw', data)
    },
    getSocreByMcqs: (data) => {  //普通评分-选择题(MCQS,MCQM,MCQS,MCQM,HCS,SMW)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByMcqs', data)
    },
    getSocreByRo: (data) => {  //普通评分-(RO)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByRo', data)
    },
    
     submitOneSpeaking: (data) => {  //提交口语答案(RA一句话模式)
        return post(api + 'jeecg-boot/web/submitQuestions/submitOneSpeaking', data)
    },
     aiSocreByDiAndRl: (data) => {  //AI评分(口语-DI,RL)
        return post(api + 'jeecg-boot/web/submitQuestions/aiSocreByDiAndRl', data)
    },
    
    
    
    submitFiblQuestions: (data) => {  //提交听力答案(FIB-L)
        return post(api + 'jeecg-boot/web/submitQuestions/submitFiblQuestions', data)
    },
     submitFibrQuestions: (data) => {  //提交阅读答案(FIB-R)
        return post(api + 'jeecg-boot/web/submitQuestions/submitFibrQuestions', data)
    },
     submitFibrwQuestions: (data) => {  //提交阅读答案(FIB-RW)
        return post(api + 'jeecg-boot/web/submitQuestions/submitFibrwQuestions', data)
    },
     submitHiwQuestions: (data) => {  //提交听力答案(HIW)
        return post(api + 'jeecg-boot/web/submitQuestions/submitHiwQuestions', data)
    },
     submitMcqQuestions: (data) => {  //提交选择题答案(MCQS,MCQM,MCQS,MCQM,HCS,SMW)
        return post(api + 'jeecg-boot/web/submitQuestions/submitMcqQuestions', data)
    },
     submitRoQuestions: (data) => {  //提交阅读答案(RO)
        return post(api + 'jeecg-boot/web/submitQuestions/submitRoQuestions', data)
    },
     submitSpeakingQuestions: (data) => {  //提交口语答案(RA,RS,DI,RL,ASQ)
        return post(api + 'jeecg-boot/web/submitQuestions/submitSpeakingQuestions', data)
    },
    submitSstQuestions: (data) => {  //提交听力答案(SST)
        return post(api + 'jeecg-boot/web/submitQuestions/submitSstQuestions', data)
    },
    submitWfdQuestions: (data) => {  //提交听力答案(WFD)
        return post(api + 'jeecg-boot/web/submitQuestions/submitWfdQuestions', data)
    },
    submitWritingQuestions: (data) => {  //提交写作答案(SWT,WE)
        return post(api + 'jeecg-boot/web/submitQuestions/submitWritingQuestions', data)
    },
    
    queryAiQualifyNum: (data) => {  //查看免费ai评分次数
        return post(api + 'jeecg-boot/web/submitQuestions/queryAiQualifyNum', data)
    },
    
    
    //ai评分
    aiSocreByOneSpeaking: (data) => { //AI评分(口语-RA一句话模式)
        return get(api + 'jeecg-boot/web/submitQuestions/aiSocreByOneSpeaking', data)
    },
    aiSocreBySpeaking: (data) => {  //AI评分(口语-RA,RS,DI,RL)
        return get(api + 'jeecg-boot/web/submitQuestions/aiSocreBySpeaking', data)
    },
    getAiSocreByAsq: (data) => {  //AI评分-(口语-ASQ)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreByAsq', data)
    },
    getAiSocreBySst: (data) => {  //AI评分-(SST)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreBySst', data)
    },
    getAiSocreBySwt: (data) => {  //AI评分-(SWT)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreBySwt', data)
    },
    getAiSocreByWe: (data) => {  //AI评分-(WE)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreByWe', data)
    },
    getAiSocreByWfd: (data) => {  //AI评分-(WFD)
        return get(api + 'jeecg-boot/web/submitQuestions/getAiSocreByWfd', data)
    },
    getSocreByFibl: (data) => {  //普通评分-(FIB-L)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByFibl', data)
    },
    getSocreByFibr: (data) => {  //普通评分-(FIB-R)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByFibr', data)
    },
    getSocreByFibrw: (data) => {  //普通评分-(FIB-RW)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByFibrw', data)
    },
     getSocreByHiw: (data) => {  //普通评分-(HIW)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByHiw', data)
    },
     getSocreByMcqs: (data) => {  //普通评分-选择题(MCQS,MCQM,MCQS,MCQM,HCS,SMW)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByMcqs', data)
    },
     getSocreByRo: (data) => {  //普通评分-(RO)
        return get(api + 'jeecg-boot/web/submitQuestions/getSocreByRo', data)
    },
     queryAiQualify: (data) => {  //查询是否有ai评分资格
        return post(api + 'jeecg-boot/web/submitQuestions/queryAiQualify', data)
    },
    
    selectMyNoteList: (data) => {  //我的笔记列表	
        return post(api + 'jeecg-boot/web/submitQuestions/selectMyNoteList', data)
    },
    
    
    //支付
    alipay: (data) => {  //支付宝支付
        return post(api + 'jeecg-boot/web/ali/pay', data)
    },
    alicallBack: (data) => {  //支付宝支付回调
        return get(api + 'jeecg-boot/web/ali/callBack', data)
    },
    wechatpay: (data) => {  //微信支付
        return post(api + 'jeecg-boot/web/wechat/pay', data)
    },
    wechatcallBack: (data) => {  //微信支付回调
        return get(api + 'jeecg-boot/web/wechat/callBack', data)
    },
    getIsPay: (data) => {  //查询是否支付
        return get(api + 'jeecg-boot/web/wechat/getIsPay', data)
    },
    stripe: (data) => {  //银行卡支付	
        return post(api + 'jeecg-boot/web/stripe/pay', data)
    },
    
    
    
    getsig: (data) => {  
        return get(api + 'jeecg-boot/web/home/getChivoxSign', data)
    },
    
    searchQuestionsByCode: (data) => {
        return get(api + 'jeecg-boot/web/questions/searchQuestionsByCode', data)
    },

    // 翻译接口
    translateText: (data) => {  // 翻译文本
        return post(api + 'jeecg-boot/web/translate/translateText', data)
    },

    recordUserAnswerPlan:(data)=>{ //记录用户答题进度
        return post(api + 'jeecg-boot/web/questions/recordUserAnswerPlan',data)
    },

    // 生词本相关接口
    addMyWordBook: (data) => {  // 加入生词本
        return post(api + 'jeecg-boot/web/word/addMyWordBook', data)
    },

    //社区论坛
    getCommunityCategoryList: () => {
        return get(api + 'jeecg-boot/web/community/category/list')
    },
    getCommunityPostList: (data) => {
        return get(api + 'jeecg-boot/web/community/post/list',data)
    },
    addCommunityPost: (data) => {
        return post(api + 'jeecg-boot/web/community/post/publish',data)
    },
    delCommunityPost: (id) => {
        return deleteUrl(api + 'jeecg-boot/web/community/post/removePost/'+id)
    },
    addCommunityComment: (data) => {
        return post(api + 'jeecg-boot/web/community/comment/publish',data)
    },
}




// WEBPACK FOOTER //
// ./src/api/protal.js